'use strict';

let MultiValueAutocompleteDirective=require('../multiValueAutocompleteDirective/multiValueAutocompleteDirective');let

AddPersonAutocompleteDirective=class AddPersonAutocompleteDirective extends MultiValueAutocompleteDirective{
get templateUrl(){return'/templates/directives/addPersonAutocompleteDirective/addPersonAutocompleteTemplate'}};


module.exports=AddPersonAutocompleteDirective;
//# sourceMappingURL=addPersonAutocompleteDirective.js.map
